import { ErrorCode } from '@gr/core/errors';

// Тексты ошибок по кодам ErrorCode — общие для всех контекстов.
const errorsRu: Record<ErrorCode | 'UNKNOWN', string> = {
  BAD_REQUEST: 'Запрос составлен неверно.',
  UNAUTHORIZED: 'Сессия истекла. Войдите снова.',
  FORBIDDEN: 'Недостаточно прав для этого действия.',
  NOT_FOUND: 'Не найдено.',
  VALIDATION_FAILED: 'Проверьте поля формы.',
  INTERNAL_ERROR: 'Что-то пошло не так. Попробуйте ещё раз.',
  INVALID_CREDENTIALS: 'Неверный логин или пароль.',
  LOGIN_THROTTLED: 'Слишком много попыток входа. Попробуйте через 15 минут.',
  USER_DISABLED: 'Пользователь заблокирован.',
  LOGIN_INVALID: 'Логин: 3–32 символа — латиница, цифры, точка, дефис, подчёркивание.',
  LOGIN_ALREADY_EXISTS: 'Такой логин уже занят.',
  PASSWORD_TOO_SHORT: 'Пароль должен быть не короче 8 символов.',
  CURRENT_PASSWORD_INVALID: 'Текущий пароль указан неверно.',
  DISPLAY_NAME_INVALID: 'Укажите имя (до 100 символов).',
  USER_NOT_FOUND: 'Пользователь не найден.',
  LAST_ADMIN: 'Нельзя лишить системы последнего администратора.',
  CANNOT_DISABLE_SELF: 'Нельзя заблокировать самого себя.',
  API_KEY_NOT_FOUND: 'Ключ API не найден.',
  API_KEY_SCOPE_DENIED: 'Ключ API не даёт доступа к этому действию.',
  API_KEY_NAME_INVALID: 'Укажите название ключа (до 100 символов).',
  API_KEY_SCOPES_INVALID: 'Выберите хотя бы одну область доступа.',
  API_KEY_LIMIT_REACHED: 'Достигнут предел действующих ключей. Отзовите ненужный.',
  API_KEY_ACTIVE_IN_USE: 'Ключ ещё действует. Сначала отзовите его, потом удалите.',
  REGISTRATION_DISABLED: 'Регистрация закрыта. Учётную запись заводит администратор.',
  REGISTRATION_THROTTLED: 'Сейчас регистрируется слишком много людей. Попробуйте через час.',
  PASSWORD_MISMATCH: 'Пароли не совпадают.',
  BLOG_NOT_FOUND: 'Блог не найден.',
  BLOG_NAME_INVALID: 'Укажите название блога (до 100 символов).',
  TIMEZONE_INVALID: 'Неизвестный часовой пояс.',
  MEMBER_NOT_FOUND: 'Участник не найден.',
  MEMBER_ALREADY_EXISTS: 'Этот пользователь уже участник блога.',
  LAST_OWNER: 'У блога должен остаться хотя бы один владелец.',
  BLOG_ACCOUNT_MEMBER: 'Блог записан на тариф этого участника: его нельзя исключить или понизить.',
  ENTITY_TYPE_NOT_FOUND: 'Справочник не найден.',
  ENTITY_TYPE_NAME_INVALID: 'Укажите название справочника.',
  ENTITY_TYPE_HAS_ENTITIES_IN_USE: 'В справочнике есть записи — сначала удалите их.',
  ENTITY_TYPE_REFERENCED_IN_USE: 'На этот справочник ссылаются поля других справочников или постов.',
  FIELD_DEFINITION_INVALID: 'Поле настроено неверно.',
  FIELD_KEY_ALREADY_EXISTS: 'Поле с таким ключом уже есть.',
  FIELD_TYPE_CHANGE_FORBIDDEN: 'Тип существующего поля менять нельзя — удалите поле и создайте новое.',
  TITLE_FIELD_INVALID: 'Заголовок записи — обязательное текстовое поле.',
  SELECT_OPTIONS_REQUIRED: 'Добавьте варианты выбора.',
  REFERENCE_TARGET_INVALID: 'Выберите, на что ссылается поле.',
  ENTITY_NOT_FOUND: 'Запись не найдена.',
  ENTITY_REFERENCED_IN_USE: 'На запись ссылаются — сначала уберите ссылки.',
  FIELD_REQUIRED: 'Обязательное поле.',
  FIELD_TOO_LONG: 'Слишком длинное значение.',
  FIELD_MULTILINE: 'Только одна строка.',
  FIELD_NOT_NUMBER: 'Нужно число.',
  FIELD_OUT_OF_RANGE: 'Значение вне допустимых границ.',
  FIELD_RATING_INVALID: 'Оценка от 0.5 до 5 с шагом 0.5.',
  FIELD_NOT_BOOLEAN: 'Нужно «да» или «нет».',
  FIELD_DATE_INVALID: 'Неверная дата.',
  FIELD_URL_INVALID: 'Ссылка должна начинаться с http:// или https://.',
  FIELD_OPTION_INVALID: 'Выберите вариант из списка.',
  FIELD_REFERENCE_INVALID: 'Выбранная запись не подходит.',
  POST_NOT_FOUND: 'Пост не найден.',
  POST_TITLE_INVALID: 'Укажите название поста (до 200 символов).',
  POST_HAS_PUBLICATIONS_IN_USE: 'У поста есть вышедшие или ожидающие публикации — переведите его в «неактуален».',
  POST_STATUS_NOT_FOUND: 'Статус не найден.',
  STATUS_NAME_INVALID: 'Укажите название статуса (до 50 символов).',
  STATUS_COLOR_INVALID: 'Цвет в формате #RRGGBB.',
  STATUS_LAST_OF_META: 'Для каждого метастатуса должен остаться хотя бы один статус.',
  STATUS_REPLACEMENT_REQUIRED: 'Выберите статус, на который перенести посты.',
  STATUS_ORDER_INVALID: 'Порядок статусов устарел — обновите страницу.',
  HASHTAG_INVALID: 'Хештеги — только буквы, цифры и подчёркивание.',
  MEDIA_DUPLICATE_IN_POST: 'Это медиа уже есть в посте.',
  POST_MEDIA_EXCLUDED_UNKNOWN: 'Отметить для публикации можно только медиа этого поста.',
  POST_SOURCE_REQUIRED: 'Укажите метку источника поста: по ключу API посты создаются только с ней.',
  POST_SOURCE_INVALID: 'Метка источника: непустая строка до 200 символов без переводов строки.',
  POST_CREATED_AT_INVALID: 'Дата создания поста — дата в прошлом в формате ГГГГ-ММ-ДД или ISO 8601.',
  POST_CHANGED: 'Пост уже изменили после того, как вы его открыли. Обновите страницу и повторите.',
  POST_FORMAT_NOT_FOUND: 'Правило оформления не найдено.',
  POST_FORMAT_NAME_INVALID: 'Тип правила: от 1 до 100 символов.',
  POST_FORMAT_NAME_ALREADY_EXISTS: 'Правило с таким типом уже есть.',
  POST_FORMAT_DEFAULT_REQUIRED: 'Сначала отметьте правилом по умолчанию другое правило.',
  MEDIA_NOT_FOUND: 'Медиа не найдено.',
  MEDIA_TYPE_UNSUPPORTED: 'Формат файла не поддерживается.',
  MEDIA_TOO_LARGE: 'Файл слишком большой.',
  MEDIA_EMPTY: 'Пустой файл.',
  MEDIA_NAME_REQUIRED: 'У файла нет имени.',
  MEDIA_ATTACHED_IN_USE: 'Медиа прикреплено к постам — сначала открепите его.',
  MEDIA_NOTE_TOO_LONG: 'Заметка слишком длинная.',
  MEDIA_TRAFFIC_LIMIT_EXCEEDED: 'Месячный лимит трафика блога исчерпан: скачивание оригиналов и пакетов возобновится в начале следующего месяца или после увеличения лимита.',
  MEDIA_RECOMPRESS_UNAVAILABLE: 'Пережатие недоступно: на сервере нет обработчика медиа (ffmpeg).',
  MEDIA_RECOMPRESS_TARGET_UNSUPPORTED: 'Этот формат обработчик медиа на сервере не умеет.',
  MEDIA_RECOMPRESS_NOTHING: 'В выбранных форматах нет файлов — пережимать нечего.',
  MEDIA_FILE_MISSING: 'Файла нет в хранилище.',
  MEDIA_DECODE_FAILED: 'Файл не удалось прочитать: он повреждён или формат не поддерживается.',
  MEDIA_ENCODE_FAILED: 'Файл не удалось пережать.',
  MEDIA_VERIFY_FAILED: 'Пережатый файл не прошёл проверку — оставлен исходный.',
  MEDIA_HDR_UNSUPPORTED: 'HDR-видео: обработчик на сервере не умеет приводить его к обычному диапазону.',
  MEDIA_PROCESSING_TIMEOUT: 'Обработка файла заняла слишком много времени и прервана.',
  MEDIA_PROCESSOR_UNAVAILABLE: 'Обработчик медиа (ffmpeg) недоступен на сервере.',
  TEMP_DISK_FULL: 'На сервере не хватает места во временном каталоге.',
  CHANNEL_NOT_FOUND: 'Канал не найден.',
  CHANNEL_NAME_INVALID: 'Укажите название канала (до 100 символов).',
  CHANNEL_URL_INVALID: 'Ссылка должна начинаться с http:// или https://.',
  CHANNEL_HAS_PUBLICATIONS_IN_USE: 'У канала есть публикации — его можно только отключить.',
  CHANNEL_IN_SCHEME_IN_USE: 'Канал входит в схему публикации — сначала уберите его из схем.',
  SLOT_INVALID: 'Неверный слот: день 1–7 и время ЧЧ:ММ.',
  SCHEME_NOT_FOUND: 'Схема не найдена.',
  SCHEME_NAME_INVALID: 'Укажите название схемы.',
  SCHEME_STEPS_INVALID: 'Проверьте шаги схемы.',
  SCHEME_CHANNEL_INVALID: 'В схеме можно использовать только включённые каналы блога.',
  SCHEME_CHANNEL_DUPLICATE: 'Канал повторяется в схеме.',
  SCHEME_IN_USE: 'По этой схеме стоят посты в очереди.',
  POST_NOT_READY: 'Планировать можно только готовый пост.',
  POST_ALREADY_SCHEDULED: 'Пост уже запланирован — сначала снимите его с плана.',
  TIME_IN_PAST: 'Время уже прошло.',
  QUEUE_ITEM_NOT_FOUND: 'Пост уже не в очереди.',
  QUEUE_ORDER_INVALID: 'Очередь изменилась — обновите страницу.',
  PUBLICATION_NOT_FOUND: 'Публикация не найдена.',
  PUBLICATION_NOT_PLANNED: 'Публикация уже не запланирована.',
  PUBLICATION_NOT_DUE: 'Запланированную публикацию снимают в плане.',
  PUBLICATION_ALREADY_FINAL: 'Публикация уже отмечена.',
  PUBLICATION_NOT_PUBLISHED: 'Публикация ещё не вышла: ожидающую отмечают или отменяют, запланированную меняют в плане.',
  PUBLISHED_URL_INVALID: 'Ссылка должна начинаться с http:// или https://.',
  PUBLISHED_AT_IN_FUTURE: 'Время выхода не может быть в будущем.',
  DATABASE_UNAVAILABLE: 'База данных недоступна.',
  STORAGE_UNAVAILABLE: 'Хранилище файлов не ответило.',
  DATASET_DATABASE_NOT_EMPTY: 'База не пустая.',
  SETTING_NOT_FOUND: 'Такой настройки нет.',
  CONFIG_VALUE_INVALID: 'Недопустимое значение настройки: проверьте тип и диапазон.',
  CONFIG_NOT_EDITABLE: 'Эту настройку можно изменить только окружением сервера.',
  DEMO_PROTECTED: 'В демо-режиме это изменить нельзя: демо общее для всех посетителей.',
  PLAN_NOT_FOUND: 'Тарифный план не найден.',
  PLAN_NAME_INVALID: 'Укажите название плана (до 100 символов).',
  PLAN_DESCRIPTION_INVALID: 'Описание плана — до 1000 символов.',
  PLAN_CODE_INVALID: 'Код: 2–32 символа — латиница в нижнем регистре, цифры и дефис.',
  PLAN_CODE_ALREADY_EXISTS: 'План с таким кодом уже есть.',
  PLAN_LIMIT_INVALID: 'Лимит — целое число от 0 или «без ограничения».',
  PLAN_ARCHIVED: 'План в архиве: его нельзя назначить или сделать планом по умолчанию.',
  PLAN_DEFAULT_IN_USE: 'План по умолчанию нельзя отправить в архив: сначала отметьте другой.',
  PLAN_LIMIT_BLOGS: 'Тариф не позволяет завести ещё один блог. Сменить тариф может администратор платформы.',
  PLAN_LIMIT_EDITORS: 'Тариф не позволяет добавить ещё одного редактора. Наблюдателей можно добавлять без ограничений.',
  PLAN_LIMIT_STORAGE: 'Медиатеки заняли всё место по тарифу. Удалите ненужные медиа или смените тариф.',
  PLAN_LIMIT_MEDIA_PER_DAY: 'Исчерпан лимит загрузок медиа за сутки по тарифу. Попробуйте позже.',
  PLAN_LIMIT_POSTS_PER_DAY: 'Исчерпан лимит новых постов за сутки по тарифу. Попробуйте позже.',
  TASK_NOT_FOUND: 'Фоновая задача не найдена.',
  TASK_ALREADY_ACTIVE: 'В блоге уже идёт фоновая задача: новую можно поставить, когда она завершится.',
  TASK_ALREADY_FINISHED: 'Задача уже завершена или отменена.',
  TASK_NOT_PAUSED: 'Возобновить можно только приостановленную задачу.',
  TASK_TOO_MANY_FAILURES: 'Подряд слишком много ошибок — задача приостановлена.',
  BACKUP_NOT_FOUND: 'Резервной копии нет — возможно, её уже удалили.',
  BACKUP_INVALID: 'Это не резервная копия GenRaskladka или файл повреждён.',
  BACKUP_IN_USE: 'Копию сейчас создают или восстанавливают — удалить её можно после окончания.',
  BACKUP_TASKS_ACTIVE: 'На платформе идут фоновые задачи — дождитесь их окончания или отмените их.',
  BACKUP_NEWER_VERSION: 'Копия сделана более новой версией сайта — сначала обновите сайт.',
  BACKUP_FILE_CORRUPTED: 'Файл в копии повреждён: контрольная сумма не сходится.',
  UNKNOWN: 'Ошибка: {code}',
};

const errorsEn: typeof errorsRu = {
  BAD_REQUEST: 'The request is malformed.',
  UNAUTHORIZED: 'Your session expired. Sign in again.',
  FORBIDDEN: "You don't have permission to do this.",
  NOT_FOUND: 'Not found.',
  VALIDATION_FAILED: 'Check the form fields.',
  INTERNAL_ERROR: 'Something went wrong. Try again.',
  INVALID_CREDENTIALS: 'Wrong login or password.',
  LOGIN_THROTTLED: 'Too many sign-in attempts. Try again in 15 minutes.',
  USER_DISABLED: 'This user is disabled.',
  LOGIN_INVALID: 'Login: 3–32 characters — latin letters, digits, dot, dash, underscore.',
  LOGIN_ALREADY_EXISTS: 'This login is taken.',
  PASSWORD_TOO_SHORT: 'Password must be at least 8 characters.',
  CURRENT_PASSWORD_INVALID: 'Current password is wrong.',
  DISPLAY_NAME_INVALID: 'Enter a name (up to 100 characters).',
  USER_NOT_FOUND: 'User not found.',
  LAST_ADMIN: "The last administrator can't lose admin rights.",
  CANNOT_DISABLE_SELF: "You can't disable yourself.",
  API_KEY_NOT_FOUND: 'API key not found.',
  API_KEY_SCOPE_DENIED: "This API key doesn't allow this action.",
  API_KEY_NAME_INVALID: 'Enter a key name (up to 100 characters).',
  API_KEY_SCOPES_INVALID: 'Choose at least one access scope.',
  API_KEY_LIMIT_REACHED: 'Active key limit reached. Revoke one you no longer need.',
  API_KEY_ACTIVE_IN_USE: 'The key is still active. Revoke it first, then delete it.',
  REGISTRATION_DISABLED: 'Sign-up is closed. Accounts are created by the administrator.',
  REGISTRATION_THROTTLED: 'Too many people are signing up right now. Try again in an hour.',
  PASSWORD_MISMATCH: 'The passwords do not match.',
  BLOG_NOT_FOUND: 'Blog not found.',
  BLOG_NAME_INVALID: 'Enter a blog name (up to 100 characters).',
  TIMEZONE_INVALID: 'Unknown time zone.',
  MEMBER_NOT_FOUND: 'Member not found.',
  MEMBER_ALREADY_EXISTS: 'This user is already a member.',
  LAST_OWNER: 'A blog needs at least one owner.',
  BLOG_ACCOUNT_MEMBER: "The blog is on this member's plan: they cannot be removed or demoted.",
  ENTITY_TYPE_NOT_FOUND: 'Reference not found.',
  ENTITY_TYPE_NAME_INVALID: 'Enter a reference name.',
  ENTITY_TYPE_HAS_ENTITIES_IN_USE: 'The reference has records — delete them first.',
  ENTITY_TYPE_REFERENCED_IN_USE: 'Fields of other references or posts point to this one.',
  FIELD_DEFINITION_INVALID: 'The field is misconfigured.',
  FIELD_KEY_ALREADY_EXISTS: 'A field with this key already exists.',
  FIELD_TYPE_CHANGE_FORBIDDEN: "An existing field's type can't change — delete it and add a new one.",
  TITLE_FIELD_INVALID: 'The record title must be a required text field.',
  SELECT_OPTIONS_REQUIRED: 'Add choice options.',
  REFERENCE_TARGET_INVALID: 'Choose what the field links to.',
  ENTITY_NOT_FOUND: 'Record not found.',
  ENTITY_REFERENCED_IN_USE: 'Other items link to this record — remove the links first.',
  FIELD_REQUIRED: 'Required field.',
  FIELD_TOO_LONG: 'The value is too long.',
  FIELD_MULTILINE: 'Single line only.',
  FIELD_NOT_NUMBER: 'Enter a number.',
  FIELD_OUT_OF_RANGE: 'The value is out of range.',
  FIELD_RATING_INVALID: 'Rating from 0.5 to 5 in steps of 0.5.',
  FIELD_NOT_BOOLEAN: 'Choose yes or no.',
  FIELD_DATE_INVALID: 'Invalid date.',
  FIELD_URL_INVALID: 'The link must start with http:// or https://.',
  FIELD_OPTION_INVALID: 'Choose an option from the list.',
  FIELD_REFERENCE_INVALID: "The selected record doesn't fit.",
  POST_NOT_FOUND: 'Post not found.',
  POST_TITLE_INVALID: 'Enter a post title (up to 200 characters).',
  POST_HAS_PUBLICATIONS_IN_USE: 'The post has published or pending publications — mark it as retired instead.',
  POST_STATUS_NOT_FOUND: 'Status not found.',
  STATUS_NAME_INVALID: 'Enter a status name (up to 50 characters).',
  STATUS_COLOR_INVALID: 'Color as #RRGGBB.',
  STATUS_LAST_OF_META: 'Every meta status needs at least one status.',
  STATUS_REPLACEMENT_REQUIRED: 'Choose a status to move the posts to.',
  STATUS_ORDER_INVALID: 'Status order is outdated — refresh the page.',
  HASHTAG_INVALID: 'Hashtags may contain letters, digits and underscores only.',
  MEDIA_DUPLICATE_IN_POST: 'This media is already in the post.',
  POST_MEDIA_EXCLUDED_UNKNOWN: 'Only media of this post can be marked for publishing.',
  POST_SOURCE_REQUIRED: 'Set the post source mark: posts created with an API key require it.',
  POST_SOURCE_INVALID: 'Source mark: a non-empty single line up to 200 characters.',
  POST_CREATED_AT_INVALID: 'Post creation date must be in the past, as YYYY-MM-DD or ISO 8601.',
  POST_CHANGED: 'The post was changed after you opened it. Reload the page and try again.',
  POST_FORMAT_NOT_FOUND: 'Formatting rule not found.',
  POST_FORMAT_NAME_INVALID: 'Rule type: 1 to 100 characters.',
  POST_FORMAT_NAME_ALREADY_EXISTS: 'A rule of this type already exists.',
  POST_FORMAT_DEFAULT_REQUIRED: 'Mark another rule as the default first.',
  MEDIA_NOT_FOUND: 'Media not found.',
  MEDIA_TYPE_UNSUPPORTED: 'This file format is not supported.',
  MEDIA_TOO_LARGE: 'The file is too large.',
  MEDIA_EMPTY: 'The file is empty.',
  MEDIA_NAME_REQUIRED: 'The file has no name.',
  MEDIA_ATTACHED_IN_USE: 'The media is attached to posts — detach it first.',
  MEDIA_NOTE_TOO_LONG: 'The note is too long.',
  MEDIA_TRAFFIC_LIMIT_EXCEEDED: "The blog's monthly traffic limit is used up: originals and packages can be downloaded again next month or after the limit is raised.",
  MEDIA_RECOMPRESS_UNAVAILABLE: 'Recompression is unavailable: the server has no media processor (ffmpeg).',
  MEDIA_RECOMPRESS_TARGET_UNSUPPORTED: 'The media processor on the server does not support this format.',
  MEDIA_RECOMPRESS_NOTHING: 'There are no files in the selected formats — nothing to recompress.',
  MEDIA_FILE_MISSING: 'The file is missing from the storage.',
  MEDIA_DECODE_FAILED: 'The file could not be read: it is damaged or the format is not supported.',
  MEDIA_ENCODE_FAILED: 'The file could not be recompressed.',
  MEDIA_VERIFY_FAILED: 'The recompressed file failed the check — the original is kept.',
  MEDIA_HDR_UNSUPPORTED: 'HDR video: the media processor on the server cannot convert it to standard range.',
  MEDIA_PROCESSING_TIMEOUT: 'Processing the file took too long and was stopped.',
  MEDIA_PROCESSOR_UNAVAILABLE: 'The media processor (ffmpeg) is unavailable on the server.',
  TEMP_DISK_FULL: 'The server is out of space in the temporary directory.',
  CHANNEL_NOT_FOUND: 'Channel not found.',
  CHANNEL_NAME_INVALID: 'Enter a channel name (up to 100 characters).',
  CHANNEL_URL_INVALID: 'The link must start with http:// or https://.',
  CHANNEL_HAS_PUBLICATIONS_IN_USE: 'The channel has publications — you can only disable it.',
  CHANNEL_IN_SCHEME_IN_USE: 'The channel is used in a scheme — remove it from schemes first.',
  SLOT_INVALID: 'Invalid slot: day 1–7 and time HH:MM.',
  SCHEME_NOT_FOUND: 'Scheme not found.',
  SCHEME_NAME_INVALID: 'Enter a scheme name.',
  SCHEME_STEPS_INVALID: 'Check the scheme steps.',
  SCHEME_CHANNEL_INVALID: 'Only enabled channels of the blog can be used.',
  SCHEME_CHANNEL_DUPLICATE: 'A channel repeats in the scheme.',
  SCHEME_IN_USE: 'Posts in the queue use this scheme.',
  POST_NOT_READY: 'Only ready posts can be scheduled.',
  POST_ALREADY_SCHEDULED: 'The post is already scheduled — unschedule it first.',
  TIME_IN_PAST: 'That time has passed.',
  QUEUE_ITEM_NOT_FOUND: 'The post is no longer in the queue.',
  QUEUE_ORDER_INVALID: 'The queue changed — refresh the page.',
  PUBLICATION_NOT_FOUND: 'Publication not found.',
  PUBLICATION_NOT_PLANNED: 'The publication is no longer scheduled.',
  PUBLICATION_NOT_DUE: 'Unschedule planned publications from the plan.',
  PUBLICATION_ALREADY_FINAL: 'The publication is already marked.',
  PUBLICATION_NOT_PUBLISHED: 'The publication has not gone out yet: mark or cancel a due one, change a planned one in the plan.',
  PUBLISHED_URL_INVALID: 'The link must start with http:// or https://.',
  PUBLISHED_AT_IN_FUTURE: "Publication time can't be in the future.",
  DATABASE_UNAVAILABLE: 'The database is unavailable.',
  STORAGE_UNAVAILABLE: 'File storage did not respond.',
  DATASET_DATABASE_NOT_EMPTY: 'The database is not empty.',
  SETTING_NOT_FOUND: 'There is no such setting.',
  CONFIG_VALUE_INVALID: 'Invalid setting value: check its type and range.',
  CONFIG_NOT_EDITABLE: 'This setting can be changed only in the server environment.',
  DEMO_PROTECTED: 'This cannot be changed in demo mode: the demo is shared by all visitors.',
  PLAN_NOT_FOUND: 'Plan not found.',
  PLAN_NAME_INVALID: 'Enter a plan name (up to 100 characters).',
  PLAN_DESCRIPTION_INVALID: 'Plan description is up to 1000 characters.',
  PLAN_CODE_INVALID: 'Code: 2–32 characters — lowercase Latin letters, digits and hyphens.',
  PLAN_CODE_ALREADY_EXISTS: 'A plan with this code already exists.',
  PLAN_LIMIT_INVALID: 'A limit is a whole number from 0 or "unlimited".',
  PLAN_ARCHIVED: 'The plan is archived: it cannot be assigned or made the default.',
  PLAN_DEFAULT_IN_USE: 'The default plan cannot be archived: mark another one first.',
  PLAN_LIMIT_BLOGS: 'Your plan does not allow another blog. A platform administrator can change your plan.',
  PLAN_LIMIT_EDITORS: 'Your plan does not allow another editor. Viewers can be added without limits.',
  PLAN_LIMIT_STORAGE: 'Media libraries have used all the space of your plan. Delete unneeded media or change the plan.',
  PLAN_LIMIT_MEDIA_PER_DAY: 'The daily media upload limit of your plan is used up. Try again later.',
  PLAN_LIMIT_POSTS_PER_DAY: 'The daily new post limit of your plan is used up. Try again later.',
  TASK_NOT_FOUND: 'Background task not found.',
  TASK_ALREADY_ACTIVE: 'A background task is already running in this blog: a new one can be started when it finishes.',
  TASK_ALREADY_FINISHED: 'The task has already finished or been cancelled.',
  TASK_NOT_PAUSED: 'Only a paused task can be resumed.',
  TASK_TOO_MANY_FAILURES: 'Too many errors in a row — the task is paused.',
  BACKUP_NOT_FOUND: 'The backup does not exist — it may have been deleted.',
  BACKUP_INVALID: 'This is not a GenRaskladka backup, or the file is damaged.',
  BACKUP_IN_USE: 'The backup is being created or restored — it can be deleted once that finishes.',
  BACKUP_TASKS_ACTIVE: 'Background tasks are running on the platform — wait for them to finish or cancel them.',
  BACKUP_NEWER_VERSION: 'The backup was made by a newer version of the site — update the site first.',
  BACKUP_FILE_CORRUPTED: 'A file in the backup is damaged: its checksum does not match.',
  UNKNOWN: 'Error: {code}',
};

export const ru = {
  errors: errorsRu,
};

export const en: typeof ru = {
  errors: errorsEn,
};
